var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row-ic row-ic--skeleton" }, [
      _c("div", { staticClass: "row-ic__content" }, [
        _c("div", { staticClass: "row-ic--left" }, [
          _c("div", { staticClass: "skeleton skeleton-icon" }),
          _c("div", { staticClass: "skeleton skeleton-ic-title" }),
          _c("div", { staticClass: "skeleton skeleton-badge" })
        ]),
        _c("div", { staticClass: "skeleton skeleton-period" })
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }